/** Compatible with both legacy password provisioning and Auth V3 responses. */
export type UserCreationCredentials = {
  loginMethod?: 'PASSWORDLESS';
  temporaryPassword: string | null;
};

export const PASSWORDLESS_USER_GUIDANCE =
  'Use the business account number and your email or phone number to sign in. A verification code will be sent to you.';

export function getIdentifierConflictMessage(value: unknown): string | null {
  if (!value || typeof value !== 'object') return null;
  const error = value as { errorCode?: string; details?: { fields?: unknown } };
  if (error.errorCode !== 'C-9843') return null;
  const fields = Array.isArray(error.details?.fields) ? error.details.fields : [];
  if (fields.includes('email') && fields.includes('phone')) {
    return 'This email and phone number are already assigned to users in this business.';
  }
  if (fields.includes('phone'))
    return 'This phone number is already assigned to a user in this business.';
  if (fields.includes('email')) return 'This email is already assigned to a user in this business.';
  return 'This email or phone number is already assigned to a user in this business.';
}
